import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import EquipmentParameterForm from "components/equipments/parameters/EquipmentParameterForm";
import { createEquipmentParameter } from "graphql/mutations";
import {
  equipmentParametersByEquipmentID,
  getEquipment,
} from "graphql/queries";
import { Loader } from "@aws-amplify/ui-react";

const EquipmentParameterCreateForm = ({ equipmentID, onSuccess }) => {
  const navigate = useNavigate();
  const [companyID, setCompanyID] = useState("");
  const equipmentParameter = {
    parameterID: "",
    parameterName: "",
    parameterValue: "",
  };

  async function onSubmit(valuesParam) {
    try {
      const { parameterID, parameterName, parameterValue } = valuesParam;
      const oldEquipmentParameterData = await API.graphql(
        graphqlOperation(equipmentParametersByEquipmentID, {
          equipmentID,
          filter: {
            and: [
              {
                parameterID: { eq: parameterID },
              },
            ],
            deletedAt: { attributeExists: false },
          },
        })
      );
      const oldEquipmentParameterItems =
        oldEquipmentParameterData.data.equipmentParametersByEquipmentID.items;

      if (oldEquipmentParameterItems.length > 0) {
        toast.error(strings.parameterExists);
        return;
      }

      await API.graphql({
        query: createEquipmentParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            equipmentID,
            parameterID,
            parameterName,
            parameterValue,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/equipments");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function getCompanyFromEquipment(id) {
    try {
      const equipmentData = await API.graphql(
        graphqlOperation(getEquipment, { id })
      );
      const equipmentItem = equipmentData.data.getEquipment;
      if (!equipmentItem) {
        toast.error(strings.responses.errorFetchEquipment);
        return;
      }
      setCompanyID(equipmentItem.companyID);
    } catch (err) {
      toast.error(strings.responses.errorFetchEquipment);
    }
  }

  useEffect(() => {
    getCompanyFromEquipment(equipmentID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentID]);

  if (!companyID) return <Loader />;

  return (
    <div>
      <EquipmentParameterForm
        onSubmit={onSubmit}
        initialValues={equipmentParameter}
        companyID={companyID}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Parámetro de Equipo",
    successAdded: "Parámetro de Equipo agregado con éxito",
    parameterExists: "El parámetro ya existe en el equipo",
    responses: {
      errorFetchEquipment: "Error al consultar equipo",
    },
  },
});

export default EquipmentParameterCreateForm;
